/** Utilidades compartidas para transiciones de página por elementos (cómic, dispersión…). */

export function sortElementsForPageStagger(elements) {
	if (!Array.isArray(elements) || elements.length === 0) return [];
	return [...elements].sort((a, b) => {
		const dy = (Number(a?.y) || 0) - (Number(b?.y) || 0);
		if (Math.abs(dy) > 12) return dy;
		return (Number(a?.x) || 0) - (Number(b?.x) || 0);
	});
}

export function buildPageStaggerIndexMap(elements) {
	const sorted = sortElementsForPageStagger(elements);
	const map = new Map();
	sorted.forEach((el, i) => map.set(String(el.elementId), i));
	return { sorted, map, total: sorted.length };
}

export function computePageStaggerTimings(durationMs, totalCount, { panelRatio = 0.38 } = {}) {
	const total = Math.max(1, totalCount || 1);
	const totalSec = Math.max(0.35, (Number(durationMs) || 550) / 1000);
	const panelSec = Math.max(0.22, totalSec * panelRatio);
	const staggerSpan = Math.max(0, totalSec - panelSec);
	const stepSec = total > 1 ? staggerSpan / (total - 1) : 0;
	return { totalSec, panelSec, stepSec, delaySec: (index) => Math.max(0, index) * stepSec };
}

export function shouldApplyStaggerPageElementTransition(pageTransitionType, ctx) {
	if (!pageTransitionType || pageTransitionType === "none") return false;
	const { showWhenBtn, revealedAfter, buttonVisible } = ctx || {};
	if (showWhenBtn === "afterSeconds" && revealedAfter) return false;
	if (showWhenBtn === "afterSeconds" && !buttonVisible) return false;
	return true;
}
